module.exports = __webpack_public_path__ + "img/lodingsb.62659958.svg";